import { makeStyles } from 'tss-react/mui';

export const useModalStyles = makeStyles()(theme => ({
  root: {
    padding: 0,
  },
  modalTitle: {
    display: 'flex',
    flexGrow: 1,
    color: theme.palette.darkSlate.main,
    fontSize: '1rem',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    fontWeight: 600,
    letterSpacing: '0.5px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
      letterSpacing: '0.15px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.125rem',
      justifyContent: 'center',
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px 24px 16px',
    width: 'auto',
    paddingLeft: '16px',
    [theme.breakpoints.up('sm')]: {
      margin: '0 auto',
      padding: 0,
      width: '588px',
      '& fieldset': {
        width: '343px',
      }
    },
  },
  titleBgColor: {
    backgroundColor: theme.palette.grey[100],
  },
  paperWidthXl: {
    width: '1040px',
    height: '680px',
  },
  divider: {
    display: 'flex',
    width: '100%',
  },
  modalActionsRoot: {
    [theme.breakpoints.up('md')]: {
      marginRight: '226px',
    },
  },
  subTitle: {
    fontSize: '16px',
    color: theme.palette.text.secondary,
  },
  mobileTitle: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
  }
}));
